import React from 'react';
import MDSpinner from 'react-md-spinner';
import {saveFile, webpIsSupported} from '../../utils/FilesUtils';

export const EditImg = ({imgUrl, onDrop, clear, style, heightImg, widthImg, isLoading}) => {
  const isActive = false;

  if (isLoading) {
    return <div
      className={'fltr-img-edit-dnd-container-active'}
      style={style}
    >
      <MDSpinner size={40} singleColor={'#00DADA'}/>
    </div>;
  }

  if (!imgUrl) {
    return <div
      className={'fltr-img-edit-dnd-container' + (isActive ? '-active' : '') }
      style={style}
    >
      <img style={{width: '46px', height: '31px'}}
        src={require('../../resources/imgs/upload.png').default}
      />

      <input type="file" id="file" style={{opacity: '0', width: '100%', height: '100%', position: 'absolute'}}
        onChange={(event) => {
          if (event.target.files[0] && event.target.files[0].type.startsWith('image/')) {
            webpIsSupported(event.target.files[0], (isSupport, file) => {
              if (isSupport) {
                onDrop(file);
              }
            });
          }
        }}/>
    </div>;
  }

  return <div className= "fltr-img-edit-container" style={style}>
    <img className={'fltr-img-edit'} src={imgUrl}
      style={{height: heightImg, width: widthImg}}
      onClick={() => {
        saveFile(imgUrl);
      }}
    />
    <img className={'fltr-close-img'}
      src={require('../../resources/imgs/close.svg').default}
      onClick={clear}
    />
  </div>;
};
